import {web3Context} from "../constants";
import {Web3Store} from "../models/web3Model";

export default Web3Store.create({
    name: "",
    web3: {},
    status: web3Context.WEB3_LOADING,
    balance: "0",
    network: 0
});


// WEBPACK FOOTER //
// ./src/stores/Web3Store.js